import { FormProvider as Form, UseFormReturn } from 'react-hook-form';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
  methods: UseFormReturn<any>;
  onSubmit?: VoidFunction;
  noInheritStyle?: boolean;
};

export default function FormProvider({ children, onSubmit, methods, noInheritStyle }: Props) {
  return (
    <>
      {!noInheritStyle && (
        <div id="FORM_ID_PROVIDER_UNIQUE">
          <style>
            {` #FORM_ID_PROVIDER_UNIQUE + form {
        display: inherit;
        overflow: inherit;
        flex-direction: inherit;
        max-height: inherit;
        }`}
          </style>
        </div>
      )}
      <Form {...methods}>
        <form onSubmit={onSubmit}>{children}</form>
      </Form>
    </>
  );
}
